import type { Artist } from './types';

export const artists: Artist[] = [
  {
    slug: 'cora-levy',
    name: 'Cora Lévy',
    alias: 'cora.levy',
    since: 2013,
    origin: 'Parigi',
    basedIn: 'Milano',
    styles: ['fineline', 'handpoke'],
    instagram: 'cora.levy.tattoo',
    portrait:
      'https://images.unsplash.com/photo-1613627219991-c56672575129?w=1600&q=80&auto=format&fit=crop',
    bio: {
      it: 'Cora si forma a Parigi tra il 2013 e il 2016 nello studio di Mast Cora. Lavora esclusivamente in fine line e handpoke, con un linguaggio che mette al centro la mano, il battito, il tempo reale. Ha collaborato con Bleu Noir e Le Sphinx prima di trasferirsi a Milano nel 2019.',
      en: 'Cora trained in Paris between 2013 and 2016 at Mast Cora studio. She works exclusively in fine line and handpoke, with a language that puts the hand, the heartbeat, real-time at the centre. She collaborated with Bleu Noir and Le Sphinx before moving to Milan in 2019.',
    },
    manifesto: {
      it: 'Il fine line non è sottrazione. È disciplina.',
      en: 'Fine line isn’t subtraction. It’s discipline.',
    },
  },
  {
    slug: 'davi-marcal',
    name: 'Davi Marçal',
    alias: 'marcal',
    since: 2016,
    origin: 'São Paulo',
    basedIn: 'Milano',
    styles: ['blackwork', 'dotwork'],
    instagram: 'marcal.blackwork',
    portrait:
      'https://images.unsplash.com/photo-1697143029985-e3cf268ddff7?w=1600&q=80&auto=format&fit=crop',
    bio: {
      it: 'Davi viene dalla scuola brasiliana di blackwork pesante. Le sue composizioni occupano l’intera superficie del braccio o della schiena, costruite come architetture: pieni grandi, vuoti netti, nessun grigio. È resident a Milano dal 2021.',
      en: 'Davi comes from the heavy Brazilian blackwork school. His compositions occupy the entire surface of an arm or back, built like architectures: large solids, clean voids, no grey. Resident in Milan since 2021.',
    },
    manifesto: {
      it: 'Il nero è una decisione, non un colore.',
      en: 'Black is a decision, not a colour.',
    },
  },
  {
    slug: 'tomas-reyes',
    name: 'Tomás Reyes',
    alias: 'tomas.r',
    since: 2018,
    origin: 'Madrid',
    basedIn: 'Milano',
    styles: ['lettering', 'fineline'],
    instagram: 'tomas.r.ink',
    portrait:
      'https://images.unsplash.com/photo-1621347311611-5754c01d1fd8?w=1600&q=80&auto=format&fit=crop',
    bio: {
      it: 'Tomás è calligrafo prima di essere tatuatore. Si forma a Madrid con Ricardo Rousselot, e porta nel tatuaggio una grammatica tipografica precisa: gesto, ritmo, peso. Specializzato in script personalizzati, didone bold, lettering espressivo.',
      en: 'Tomás is a calligrapher before he is a tattooer. He trained in Madrid with Ricardo Rousselot, and brings a precise typographic grammar into tattooing: gesture, rhythm, weight. Specialised in custom script, bold didone, expressive lettering.',
    },
    manifesto: {
      it: 'Una lettera mal disegnata si vede a tre metri.',
      en: 'A badly drawn letter shows from ten feet away.',
    },
  },
  {
    slug: 'mei-kobayashi',
    name: 'Mei Kobayashi',
    alias: 'mei.k',
    since: 2014,
    origin: 'Kyoto',
    basedIn: 'Milano',
    styles: ['ornamental', 'blackwork'],
    instagram: 'mei.k.ink',
    portrait:
      'https://images.unsplash.com/photo-1675285275679-2ffd659c2ec5?w=1600&q=80&auto=format&fit=crop',
    bio: {
      it: 'Mei lavora a Milano dal 2017 dopo dieci anni a Kyoto. Specializzata in ornamentale e composizioni geometriche complesse, costruisce ogni pezzo seguendo la linea muscolare del corpo. Il suo lavoro è citato sul Tattoo Life Magazine numero 142.',
      en: 'Mei has been working in Milan since 2017 after ten years in Kyoto. Specialised in ornamental and complex geometric compositions, she builds every piece following the muscle line of the body. Her work is cited in Tattoo Life Magazine issue 142.',
    },
    manifesto: {
      it: 'Un tatuaggio si decide stando in piedi davanti allo specchio.',
      en: 'A tattoo is decided standing in front of the mirror.',
    },
  },
];

export const getArtistBySlug = (slug: string) =>
  artists.find((artist) => artist.slug === slug);
